import 'core-js/es6/map';
import 'core-js/es6/set';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Main from './Main';
import { IntlProvider,addLocaleData } from 'react-intl';
import zh from 'react-intl/locale-data/zh';
import en from 'react-intl/locale-data/en';
import pt from 'react-intl/locale-data/pt';
import intl from 'intl';
import zh_CN from './i18n/zh_CN';
import zh_MO from './i18n/zh_MO';
import en_EN from './i18n/en_EN';
import pt_PT from './i18n/pt_PT';
import queryString from 'query-string';
//import registerServiceWorker from './registerServiceWorker';

//ReactDOM.render(<App />, document.getElementById('root'));
addLocaleData([...en,...zh,...pt]);

function chooseLocale(isObject){
	const parsed = queryString.parse(document.location.search);
	const qslang = parsed.lang;
	let lang='en';

  if(qslang !== undefined){
   lang=qslang; 
  }
  else{
    if (navigator.userLanguage) // Explorer
      lang = navigator.userLanguage.split('_')[0];
    else if (navigator.language) // FF
      lang = navigator.language.split('_')[0];
    else
      lang = "en";
  }
	if(isObject){
    switch(lang){
          case 'en':
              return en_EN;
              break;
          case 'cn':
              return zh_CN;
              break;
          case 'mo':
              return zh_MO;
              break;
          case 'pt':
              return pt_PT;
              break;
          default:
              return en_EN;
              break;
      };
  }
  else{
    switch(lang){
          case 'en':
              return 'en-EN';
              break;
          case 'cn':
              return 'zh-CN';
              break;
          case 'mo':
              return 'zh-MO';
              break;
          case 'pt':
              return 'pt-PT';
              break;
          default:
              return 'en-EN';
              break;
      };

  }
     
};


ReactDOM.render(<IntlProvider 
            locale={chooseLocale(0)} 
            messages={chooseLocale(1)}
            >
            <Main />
        </IntlProvider>, document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js